import React, { Component } from "react";
import { Grid, GridColumn, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import axios from 'axios';
import { Button } from "@progress/kendo-react-buttons";
import GridLoading from '../Loaders/GridLoading';
import { process } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { parseDate } from '@telerik/kendo-intl';
import { Input } from '@progress/kendo-react-inputs';
import HouseholdDetail from './components/HouseholdDetail';
import CreateHousehold from "./components/CreateHousehold";
import HouseholdAccounts from "./components/HouseholdAccounts";
// import EntityPopup from "./components/EntityPopup";
// import CustomEntityPopup from "./components/CustomEntityPopup";

class GroupMembership extends Component {

  constructor(props) {
    super(props);

    this.minGridWidth = 0;



    var columns = [{ field: 'GroupCode', title: 'Group Code', headerClass: 'gridHeader'},
    { field: 'GroupName', title: 'Name', headerClass: 'gridHeader' },
    { field: 'edit', headerClass: 'gridHeader', filterable: false, title: ' ', cell: (p) => this.createCell(p), width: 250 },
    ]


    this.state = {
      users: [],
      roles: [],
      result: [],
      refreshText: '',
      filterable: true,
      groups: false,
      logs: false,
      columns: columns,
      dataState: { skip: 0, take: 25, sort: [{ field: 'RunDate', dir: 'asc' }, { field: 'EntityCode', dir: 'asc' }] },
      fileDownload: [],
      exportColumns: [],
      exportColumnsCustom: [],
      // advAllUsers: false,
      householdListSearchCapacity: 250000
    }

    // this.createCell = this.createCell.bind(this);
    this.getGroupMembership = this.getGroupMembership.bind(this);
    this.getDate = this.getDate.bind(this);
    this.getSuperAdminSettings = this.getSuperAdminSettings.bind(this);

  }

  componentDidMount() {
    this.getSuperAdminSettings();
    this.getStyleSettings()
    this.getGroupMembership()
  }

  componentDidUpdate() {

  }

  getStyleSettings = (cb) => {
    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

    var styleNames = ['requireTermsAndConditions,RIAFirmName,showFilters']

    axios(`api/getStyleSettings`, {
      method: 'GET',
      params: { company: this.props.user.company, styleNames: styleNames },
      headers: headers
    })
      .then(response => {
        this.setState((prevState) => {
          let obj = {
            ...prevState,
            requireTermsAndConditions: response.data.styleSettings.requireTermsAndConditions,
            filterable: response.data.styleSettings.showFilters,
            RIAFirmName: response.data.styleSettings.RIAFirmName
          };
          return obj;
        }, () => { if (cb) cb() })
      })
      .catch(err => {
        console.error(err);
        if (cb) cb()
      })
  }

  getSuperAdminSettings() {
    const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
    axios(`api/superAdminSettings`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers
    })
      .then(response => {
        response.data.data.forEach(setting => {
          if (setting.settingName === 'enableMFA') {
            this.setState({ enableMFA: setting.settingValue.toLowerCase() === 'true' ? true : false })
          }
        })

      })
      .catch(err => console.log(err));
  }

  reduceGroupMembership(input){
    return Object.values(
      input.reduce((acc, { GroupCode, GroupName, MemberCode, MemberName, MemberOrder, Consolidated }) => {
        if (!acc[GroupCode]) {
          acc[GroupCode] = { GroupCode, GroupName, members: [] };
        }
        acc[GroupCode].members.push({ MemberCode, MemberName, MemberOrder, Consolidated });
        return acc;
      }, {})
    );
  }


  getGroupMembership(cb) {
    this.setState({ refreshText: 'Loading...' });

    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

    var groupedData = [];



    axios(`api/groupMembership`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers,
    })
      .then(response => {
        console.log(response)
        groupedData = this.reduceGroupMembership(response.data.data);
        var result = process(groupedData, this.state.dataState)
        result = this.addPropertyToItems(result);
        console.log(response.data.data)
        console.log(groupedData)
        console.log(result)
        this.setState({data: response.data.data, groupedData: groupedData, result: result, refreshText: '' })

      })
      .catch(err => {
        console.error(err);
      })
  }

  formatDate(date) {
    var d;

    if (parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX")) { d = parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX") }
    else { d = parseDate(date, "MM/dd/yyyy HH:mm:ss") }

    const day = String(d.getUTCDate()).padStart(2, '0');
    const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = d.getUTCFullYear();

    return `${month}/${day}/${year}`;

  }

  getDate(sqlDate) {
    var d = parseDate(sqlDate, "yyyy-MM-ddTHH:mm:ss.SSSXXX");
    var utc = null;

    if (d !== null)
      utc = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());

    return utc;
  }

  createCell(cell) {
    return (
      <td>
        <HouseholdAccounts idToken={this.props.idToken} user={this.props.user} refresh={this.getGroupMembership} dataRow={cell.dataItem} button={<Button icon="edit" title='Edit'>Edit Group</Button>} />
        {/* <Button icon="edit" title='Edit'>Edit Group</Button> */}
        <Button icon="delete" onClick={(e) => this.onDelete(cell.dataItem.GroupCode)} title='Delete'>Delete</Button>
      </td>
    );
  }

  // expandChange = (event) => {
  //   const data = this.state.result.data.map(item =>
  //     item.id === event.dataItem.id
  //       ? {
  //         ...item,
  //         expanded: !item.expanded,
  //         enableMFA: this.state.enableMFA,
  //         templates: this.state.templates,
  //         tempDefault: this.state.tempDefault
  //       }
  //       : item
  //   );
  //   this.setState((prevState) => {
  //     let obj = { ...prevState };
  //     obj.result.data = data;
  //     return obj;
  //   })
  // };

  expandChange = (event) => {
    const expandField = event.target.props.expandField;
    const itemId = event.dataItem.id;
    console.log(event.dataItem)
    console.log(event.dataItem.id)

    const updateItemsRecursive = (items) => {
      return items.map(item => {
        let updatedItem = item;
        if (item.id === itemId) {
          updatedItem = {
            ...item,
            [expandField]: !item[expandField],
          };
        }
        if (Array.isArray(item.members)) updatedItem.members = updateItemsRecursive(item.members);
        return updatedItem;
      });
    };

    const updatedData = updateItemsRecursive(this.state.result.data);

    this.setState((prevState) => ({
      ...prevState,
      result: {
        ...prevState.result,
        data: updatedData
      }
    }));
  }

  addPropertyToItems = (obj) => {
    // Usage: (call in both initial data set and prior to any datagrid result state change)
    // result = this.addPropertyToItems(result);

    const addPropertyToNestedItems = (item) => {
      item.id = Math.random();
      item.expanded = false;

      // Recursively call this function for each item in the 'items' array
      if (Array.isArray(item.members)) item.members.forEach(subItem => addPropertyToNestedItems(subItem));
      return item;
    }

    // Traverse the array and add properties
    if (Array.isArray(obj.data)) obj.data.forEach(item => addPropertyToNestedItems(item));
    return obj;
  }

  _export;

  export = () => {
    this.setState({ exportLoadingText: 'Loading...' });

    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };



    axios(`api/groupMembershipAll`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers,
    })
      .then(response => {
        // var folder
        var exportColumns = []
        var format = ''
        var key = null
        for (let j = 0; j < Object.keys(response.data.data[0]).length; j++) {
          key = Object.keys(response.data.data[0])[j]
          if (key.toLowerCase() !== 'date') { exportColumns.push({ field: key, format: format }) }
        }

        this.setState({ groupMembershipExport: this.getFullFilteredList(response.data.data), exportColumns: exportColumns }, () => {
          this._export.save();
        })
      })
      .catch(err => {
        console.error(err);
      })

  }

  getFullFilteredList(list) {//for excel export, otherwise only the amount of users on a single page would be exported
    let noSkipDataState = { ...this.state.dataState }

    noSkipDataState.skip = null
    noSkipDataState.take = null

    return process(list, noSkipDataState).data;
    //return process(this.state.users, noSkipDataState);
  }

  changeDataState = (e) => {
    var data = { ...e.dataState }
    if (data.filter != null && data.filter.filters != null) {
      data.filter.filters.forEach(item => {
      })
      // data.filter.filters = data.filter.filters.filter(item => item.value !== '(All)');
    }
    var newData = process(this.state.groupedData, data);
    newData = this.addPropertyToItems(newData);
    this.setState({ dataState: data, result: newData });
  }

  selectionChange(event, gFiles) {
    event.dataItem.selected = !event.dataItem.selected;
    var selectedFiles = [];
    for (let i = 0; i < gFiles.length; i++) {
      if (gFiles[i].selected) {
        selectedFiles.push(gFiles[i]);
      }
    }
    this.setState({ fileDownload: selectedFiles });
    if (selectedFiles.length > 0) {
      this.setState({ fileSelected: true });
    }
    else {
      this.setState({ fileSelected: false });
    }
    this.forceUpdate();
  }

  headerSelectionChange(event, gFiles) {
    const checked = event.syntheticEvent.target.checked;
    gFiles.forEach(item => item.selected = checked);
    var selectedFiles = [];
    for (let i = 0; i < gFiles.length; i++) {
      if (gFiles[i].selected) {
        selectedFiles.push(gFiles[i]);
      }
    }
    this.setState({ fileDownload: selectedFiles });
    console.log(selectedFiles)
    if (selectedFiles.length > 0) {
      this.setState({ fileSelected: true });
    }
    else {
      this.setState({ fileSelected: false });
    }
    this.forceUpdate();
  }

  onChangeFilter = (e) =>{
    this.setState({
        searchTerm: e != null ? e.target.value : this.state.searchTerm
    },() => {
    if (this.state.data.length < this.state.householdListSearchCapacity || e == null || e.target.value === '') {

        var filter = {
            logic:"or", 
            filters:[
                {field:"GroupCode", operator:"contains", value:this.state.searchTerm},
                {field:"GroupName", operator:"contains", value:this.state.searchTerm},
                {field:"MemberCode", operator:"contains", value:this.state.searchTerm},
                {field:"MemberName", operator:"contains", value:this.state.searchTerm},
            ],
            group:"GroupCode"
        };
        var dataState = this.state.dataState;
        dataState.filter = filter;
        // var result = process(this.state.groupedData, dataState);

        // this replaces the kendo process method to mutate the groupedData into a new result
        // note that it is not as extensive as the process method, and assumes the field operator is always "contains" and logic is "or"
        var result = JSON.parse(JSON.stringify(this.state.groupedData)); // equates to a deep object copy
        result = result.filter(row => {
            let rowBool = false;
            // if we find any of the search filter columns in the top level of the row, make sure it's included in the final result
            dataState['filter']['filters'].forEach(filter => {
                if (row[filter.field] != null && String(row[filter.field]).toLowerCase().indexOf(String(this.state.searchTerm).toLowerCase()) > -1) {
                    rowBool = true;
                }
            })
            // if the top level is included, we'll include all the detail rows; otherwise, we'll filter those down to our search params
            let detailsRows = (rowBool) ? row.members : [...row.members].filter(detailRow => {
                // loop through all the detail rows, if we find any of the search filter columns at this level, make sure we show them in the final result
                let rowDetailBool = false;
                dataState['filter']['filters'].forEach(filter => {
                    if (detailRow[filter.field] != null && String(detailRow[filter.field]).toLowerCase().indexOf(String(this.state.searchTerm).toLowerCase()) > -1) {
                        rowDetailBool = true;
                    }
                })
                return rowDetailBool;
            });
            detailsRows = detailsRows.map(row => { return {...row,onAcctClick: this.props.onAccountClick}});
            // if the top level was not included but detail rows were, expand the grid automatically
            if (!rowBool && detailsRows.length > 0) {
                rowBool = true;
                row.expanded = true;
            }
            // replace the detail rows with our filtered results (if applicable)
            row.members = detailsRows;
            
            return rowBool;
        })
        this.setState({result:{data: result, total: result.length}, dataState:dataState, loading: false});
    }
    })
  }

  onDelete(GroupCode) {
    if (window.confirm('Are you sure you want to delete ' + GroupCode + '? This cannot be undone')) {
      this.setState({ refreshText: 'Loading...' })
      var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

      var payload = {
        company: this.props.user.company,
        GroupCode: GroupCode
      };

      axios.post('api/groupMembershipDelete', payload, { headers }).then(response => {
        console.log(response)
        this.setState({ fileDownload: [] })
        this.getGroupMembership();

      })
        .catch(err => {
          console.error(err);
        })
    }
  }

  render() {
    return (
      <div>
        {!this.state.groups && !this.state.logs && (
          <div className="GroupMembershipList">
            <ExcelExport data={this.state.groupMembershipExport} onExportComplete={() => { this.setState({ exportLoadingText: '' }) }} fileName='GroupMembership_Export.xlsx' ref={(exporter) => { this._export = exporter; }}>
              {this.state.exportColumns.map((column, key) => {
                return <ExcelExportColumn field={column.field} cellOptions={{ format: column.format }} title={column.field} key={key} />
              })}
            </ExcelExport>
            <Grid data={this.state.result}
              resizable={true}
              reorderable={true}
              pageable={{ pageSizes: [10, 25, 50, 100, 250, 500] }}
              // sortable={{ mode: 'multiple' }}
              expandField="expanded"
              detail={HouseholdDetail}
              onExpandChange={this.expandChange}
              onDataStateChange={this.changeDataState}
              // filterable={this.state.filterable}
              {...this.state.dataState}>
              <GridNoRecords>
                {this.state.refreshText && ''}
                {!this.state.refreshText && 'No records available'}
              </GridNoRecords>
              <GridToolbar>
                <Button icon='refresh' title='Refresh' onClick={(e) => this.getGroupMembership()}>{this.state.refreshText}</Button>
                <CreateHousehold idToken={this.props.idToken} user={this.props.user} refresh={this.getGroupMembership} create={true} button={<Button icon="plus" title='New'>Create Group</Button>} />
                <label>Search: </label><Input style={{width:'25%'}} value={this.state.searchTerm} onChange={(e)=> this.onChangeFilter(e)}/>
                <Button icon="excel" title='Export to Excel' disabled={this.state.exportLoadingText} onClick={this.export}>{this.state.exportLoadingText || 'Export'}</Button>
              </GridToolbar>
              {
                this.state.columns.map((column, key) => {
                  return <GridColumn field={column.field} title={column.title} key={key} format={column.format} cell={column.cell} filterable={column.filterable} filterCell={column.filterCell} filter={column.filter} headerClassName={column.headerClass} width={column.width} />
                })
              }
            </Grid>
            {this.state.refreshText && <GridLoading gridClass='userList' />}
          </div>)
        }
      </div>
    );
  }

}

export default GroupMembership;